import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import SubmitButton from '../../../components/form/SubmitButton';
import { useLocation, useNavigate } from 'react-router-dom';
import LoadingButton from '../../../components/form/LoadingButton';
import { apiPost } from '../../../utils/api';
import { showError, showSuccess } from '../../../utils/alert';
import InputField from '../../../components/form/InputField';

interface LoginFormData {
  phone: string;
}

export default function CustomerSendOtp() {
  const { t } = useTranslation();
  const { handleSubmit, register, formState: { errors } } = useForm<LoginFormData>();
  const [loading , setLoading] = useState(false);
  
 const navigate = useNavigate();
   const location = useLocation(); // 👈 أضف هذا


  
   
  const onSubmit = async (data: LoginFormData) => {
    try {
        setLoading(true);
      const response = await apiPost('otp-code/send/customer', {phone:`${data.phone}`}) as{status:string,code:string,phone:string};
      if (response.status === "login") {
        const message =t("signup_otp");
        showSuccess(message);
        // 👇 احصل على redirect من URL
        const params = new URLSearchParams(location.search);
        const redirect = params.get("redirect");
        navigate(`/customer/verify-otp?code=${response.code}`, { 
                  state: { phone: response.phone, redirect } 
                });      } 
      else{
        showError(t('invalid_phone'))
      }
      setLoading(false);
    } catch (err: any) {
        setLoading(false);
        showError(err.message)
    }
  };

  return (
    <div className="min-h-screen w-screen flex flex-col md:flex-row bg-light overflow-hidden">
      {/* Image Section */}
      <div className="hidden md:block md:w-1/2 h-screen">
        <img
          src={"/main.png"}
          alt="Login"
          className="w-full h-full object-cover"
        />
      </div>

      {/* Form Section */}
      <div className="flex flex-1 justify-center items-center p-8 md:p-16 min-h-screen">
        <div className="w-full max-w-md p-6 md:p-8">
          {/* Title */}
          <h1 className="text-2xl text-center font-bold text-Black mb-2">{t('login.title')}</h1>
          <p className="text-Black font-normal text-center mb-6">{t('login.headline')}</p>

          {/* Form */}
          <form onSubmit={handleSubmit(onSubmit)} className="flex flex-col gap-4" dir={"ltr"}>
            <InputField
              placeholder={t('login.phonePlaceholder')}
              register={register('phone', { required: t('login.phoneRequired') })}
              error={errors.phone}
            />
            {
              loading
              ?
              <LoadingButton height={64}/>
              :
              <SubmitButton height={64} label={t('send_opt')}/>
            }
          </form>
        </div>
      </div>
    </div>
  );
}
